import { useRef, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCube, faExpand, faMap, faRefresh } from '@fortawesome/free-solid-svg-icons';
import styled from '@emotion/styled';

import Container from '../Shared/Container';
import Dropdown from '../Shared/Dropdown';
import Button from '../Shared/Button';
import BaseLayerSelect from './BaseLayerSelect';

import { BREAKPOINTS, COLORS_BASE, STYLES } from '../../utils/consts';
import { BASE_LAYERS } from '../../utils/mapConsts';
import useDetectOutsideClick from '../../hooks/useDetectOutsideClick';
import { MapType } from '../../types/dataTypes';
import { resetMap } from '../../utils/mapDataHandler';
import { useNavigate } from 'react-router-dom';
import TooltipWrapper from '../Shared/TooltipWrapper';
import Hr from '../Shared/Hr';

type LayersProps = {
  map: MapType,
}

function Layers({ map }: LayersProps) {
  const containerRef = useRef<HTMLDivElement>(null);
  const [viewBaseLayerSelect, setViewBaseLayerSelect] = useDetectOutsideClick(containerRef, false)
  const [selectedLayer, setSelectedLayer] = useState(BASE_LAYERS[0].id);
  const [is3d, setIs3d] = useState(false);
  const navigate = useNavigate();

  function switchBetween3d() {
    const mapCurrent = map.current;
    if (!mapCurrent) return;
    // Logic to switch to 3D view
    if (!is3d) {
      mapCurrent.setPitch(60);
      setIs3d(!is3d);
    }
    else{
      mapCurrent.setPitch(0);
    }
    setIs3d(!is3d);
  }

  return (
    <LayersContainer ref={containerRef}>
      <Button onClick={() => setViewBaseLayerSelect(!viewBaseLayerSelect)} width='100%'>
        <LayerElementStyle>
            <FontAwesomeIcon icon={faMap} />
        </LayerElementStyle>
      </Button>
      <Hr color={COLORS_BASE.GREYS.LIGHTER} thickness='1px'/>
      <Dropdown viewcontainerRef={viewBaseLayerSelect}
        top='-35px'
        right={`${STYLES.PAGE_MARGIN}px`}
        padding='0px'
        left='80px'
        margin='0 0 0 0'
        width='200px'
        smallScreen={true}>
        <LayersList>
          {BASE_LAYERS.map((layer, index) => {
            return (
              <li  key={index}>
                <BaseLayerSelect layer={layer} layerArray={BASE_LAYERS} map={map} selectedLayer={selectedLayer} setSelectedLayer={setSelectedLayer} />
              </li>)
          })}
        </LayersList>
      </Dropdown> 
        <Button onClick={() => resetMap(map,navigate)} width='100%'>
          <LayerElementStyle>
            <FontAwesomeIcon icon={faExpand} />
          </LayerElementStyle>
        </Button>
        <Hr color={COLORS_BASE.GREYS.LIGHTER} thickness='1px'/>
        <TooltipWrapper content={'Switch 3D on/off. Please turn on the satellite background to see the terrain results more clearly.'} positionFromDivBottom="35px">
          <Button onClick={() => switchBetween3d()} width='100%'>
            <LayerElementStyle>
              <FontAwesomeIcon icon={faCube} style={{ color: is3d ? 'green' : 'grey' }}/>      
            </LayerElementStyle>
          </Button>
        </TooltipWrapper>
    </LayersContainer>
  )
}

export default Layers;

const LayersList = styled.ul<{}>(() => `
    list-style-type: none;
    margin: 0;
    padding: 10px 20px;
`)

const LayersContainer = styled.div<{}>(()=>`
  margin-top: 100px;
  z-index: 100;
  background-color: white;
  border-radius: 5px;

  @media (max-width: ${BREAKPOINTS.MOBILE}) {
    margin-top: 64px;
  }
`)

const LayerElementStyle = styled.div<{}>(() => `
  height: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 20px;
  pointer-events: all;
  &:hover {
    background-color: white;
  }
`);